/** @format */

import axios from "axios";

const configuratorAxios = axios.create();

export const requestConfigurator = {
  get: (path, params = {}) => configuratorAxios.get(path, { params }),
  post: (path, params = {}, options) =>
    configuratorAxios.post(path, params, options),
};
